import React, { useEffect, useState } from "react";
import { getData } from '../middleware/apiMiddleware';
import { useNavigate } from "react-router-dom";
// Make sure this import is uncommented
import s from './LuckyBagComponent.module.css'; 

export default function LuckyBagComponent({ itemId }) {	
	const navigate = useNavigate();
	
	const [luckybag, setLuckybag] = useState(null);
	
	const fetchData = () => {
		getData('item/getKeyLuckBagByItemId?item_id=' + itemId, navigate)
		.then(res => {
				setLuckybag(res.data);
			}
		);
	}
	
	useEffect(() => {
		fetchData();
	}, [itemId]);

	// Render a loading message while waiting for the data
	if (!luckybag) {
		return <div>Loading...</div>;
	}
	
	return (
        // Apply the 'wrapper' class from the CSS module
        <div className={s.wrapper}>
            <div className={s.title}>LuckyBag Details</div>

            <div className={s.detailItem}>
                <span className={s.label}>Type:</span>
                {luckybag.type}
            </div>

            <div className={s.detailItem}>
                <span className={s.label}>Difficulty:</span>
                {luckybag.difficulty}
            </div>
        </div>
    );
	
}